
"use client";

import {useFilter} from "@react-aria/i18n";
import React, { ReactNode, useEffect, useState} from "react"
import { ProductModel, ProductDB } from "../acount/ProductModel";
import { Accordion, AccordionItem } from "@heroui/accordion"; 
import { useLcgContext } from "@/config/context-conn";
import { Card, CardBody, CardFooter } from "@heroui/card";
import { Image } from "@heroui/image";
import { Button } from "react-aria-components";


export type ProductPresenterHeader = {
  label?: string | null;
  object?: string | null;
  image?: ReactNode | null;
}

export interface ProductPresenterProps {
  headers: ProductPresenterHeader[];
}

const ProductPresenter: React.FC<ProductPresenterProps> = ({
  headers
}) => {

  const [ Products, setProducts ] = React.useState<ProductModel[]>([]);
  const { products } = useLcgContext()
  
  useEffect(() => {

    const loadProducts = async () => {

      const db = await products?.Load();

      console.log(db)
      console.log(products?.Products)

        if (products?.Products != null){
          setProducts(products?.Products)
        }
      }

    loadProducts();

    }, []);
  

  return(
    <Accordion className="p-2 flex flex-col gap-1 w-full" showDivider={false} variant="splitted" selectionMode="multiple" defaultExpandedKeys={["0"]}>
    {headers.map((header, index) => (
      <AccordionItem key={index} startContent={header.image} title={header.label}>
        <div className="gap-2 grid grid-cols-2 sm:grid-cols-4">
        {
          Products.map((item) => (
            
            item.object == header.object ?
            <Card key={item.id} isPressable shadow="sm" onPress={() => console.log("item " + item.id + " pressed")}>
              <CardBody className="overflow-visible p-0">
                  <Image
                  alt={item.label}
                  className="w-full object-cover h-[140px]"
                  radius="lg"
                  shadow="sm"
                  src={"data:image/png;base64," + item.picture}
                  width="100%" />
              </CardBody>
              <CardFooter className="text-small justify-between gap-5">
                <b>{item.label}</b>
                <p className="text-default-500">{item.price.toLocaleString('cs-CZ')} Kč</p>
              </CardFooter>
            </Card>
            :
            <></>
          ))
        }
        </div>
      </AccordionItem>
    ))}
    </Accordion>
  )
}

export default ProductPresenter;
